import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import { observable } from 'mobx';
import ModuleConfigModel from 'app/stores/moduleConfig/ModuleConfigModel';
let InterfaceClassModel = (_dec = observable.ref, _class = class InterfaceClassModel extends ModuleConfigModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "interfaceGroup", _descriptor, this);
  }
  get defaults() {
    return {
      connectivityType: 'none',
      networkBoundary: 'external'
    };
  }
  get interfaceGroupDetails() {
    return {
      name: `${this.get('connectivityType')}-${this.get('networkBoundary')}`,
      type: 'ic'
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "interfaceGroup", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export default InterfaceClassModel;